import { useState } from 'react'
import { toast } from 'react-toastify'
import { API, API_ROUTER } from '../../../../../api'

const useFollowHandler = (id, name, follow) => {
  const [star, setStar] = useState(!follow)

  const followHandler = async () => {
    try {
      const followStatus = await API.request({
        ...API_ROUTER.follow.IsUserFollowTournament,
        pathKeys: {
          tournamentId: id,
        },
      })

      if (followStatus.follow === true) {
        try {
          await API.request({
            ...API_ROUTER.follow.stopFollowTournament,
            pathKeys: {
              tournamentId: id,
            },
          })
          toast.success(`You unfollowed ${name}`)
        } catch (error) {
          console.error('Unfollow error:', error)
          toast.error('Failed to unfollow tournament')
        }
      } else {
        try {
          await API.request({
            ...API_ROUTER.follow.followTournament,
            data: {
              tournamentId: id,
            },
          })
          toast.success(`You followed ${name}`)
        } catch (error) {
          console.error('Follow error:', error)
          toast.error('Failed to follow tournament')
        }
      }
    } catch (error) {
      console.error('Follow check error:', error)
      toast.error('Failed to check follow status')
    }

    if (star) {
      setStar(false)
    } else {
      setStar(true)
    }
  }

  return { star, followHandler }
}

export default useFollowHandler
